import parseIsoDuration from './parseIsoDuration';

const getDurationInMinutes = (isoDuration: string): number => {
    if (!isoDuration) {
        return 0;
    }
    const parsedDuration = parseIsoDuration(isoDuration);
    const { days, hours, minutes } = parsedDuration;
    const durationInMinutes = days * 1440 + hours * 60 + minutes;
    return durationInMinutes;
};

export default getDurationInMinutes;
